import { Injectable } from '@angular/core';

import { HtmlNode } from '@frontend/vanilla/core';
import { remove } from 'lodash-es';

import { ModalRef } from '../common/modal-ref';
import { PopupAction } from '../common/modal-window.component';
import { ModalDialogComponent } from './modal-dialog.component';

@Injectable({ providedIn: 'root' })
export class OpenedModalsStorageService {
    private openedModals: ModalRef[] = [];

    constructor(private htmlNode: HtmlNode) {}

    set openedModal(modalRef: ModalRef) {
        this.openedModals.push(modalRef);
    }

    get activeModal(): ModalRef | undefined {
        return this.openedModals[this.openedModals.length - 1];
    }

    get count(): number {
        return this.openedModals.length;
    }

    removeCurrent(modalRef: ModalRef): void {
        remove(this.openedModals, (m) => m === modalRef);
    }

    tryCloseSeeAll(isBabPopup: boolean): void {
        if (!isBabPopup) {
            return;
        }

        this.openedModals
            .find((m) => (m.componentInstance as ModalDialogComponent)?.dialogSettings.headerSelector === 'ms-option-panel-header')
            ?.close({ closeAction: PopupAction.ManualClose });

        this.htmlNode.setCssClass('sheet-view-for-market-for-sgp', false);
    }

    get edpModal(): ModalRef | undefined {
        return this.openedModals.find((m) => (m.componentInstance as ModalDialogComponent)?.dialogSettings.headerSelector === 'event-details-modal');
    }
}
